import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Menu, X } from "lucide-react";
import logo from "../pics/zipnzip.png";

export default function Navigation({ cartItems, setCartOpen }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex justify-between items-center h-20">

          {/* Logo + Brand */}
          <Link
            to="/"
            className="flex items-center text-2xl font-bold tracking-tight hover:opacity-60 transition"
            onClick={() => setMobileMenuOpen(false)}
          >
            <img src={logo} alt="ZipNZip logo" className="h-10 w-auto mr-3" />
          </Link>

          {/* Desktop Navigation */}
          <div className="flex items-center gap-8">
            <Link
              to="/"
              className="hidden sm:block text-sm hover:opacity-60 transition"
            >
              Home
            </Link>
  
            <Link
              to="/shop"
              className="hidden sm:block text-sm hover:opacity-60 transition"
            >
              Shop
            </Link>

            <Link
              to="/track"
              className="hidden sm:block text-sm hover:opacity-60 transition"
            >
              Track Order
            </Link>

            <button
              onClick={() => setCartOpen((prev) => !prev)}
              className="relative hover:opacity-60 transition"
            >
              <ShoppingCart className="w-5 h-5" />
              {cartItems.length > 0 && (
                <span className="absolute -top-2 -right-2 bg-black text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                  {cartItems.length}
                </span>
              )}
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="sm:hidden hover:opacity-60 transition"
            >
              {mobileMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>

        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="sm:hidden border-t border-gray-200 py-4">
            <div className="flex flex-col gap-4">
              <Link
                to="/"
                className="text-sm hover:opacity-60 transition py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
              
              <Link
                to="/shop"
                className="text-sm hover:opacity-60 transition py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Shop
              </Link>

              <Link
                to="/track"
                className="text-sm hover:opacity-60 transition py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Track Order
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}